"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AtLeastOneScheduled () {
        return AtLeastOneScheduled;
    },
    get AutoflowEventTrigger () {
        return AutoflowEventTrigger;
    },
    get AutoflowScheduledTrigger () {
        return AutoflowScheduledTrigger;
    },
    get AutoflowTrigger () {
        return AutoflowTrigger;
    },
    get ScheduledOptions () {
        return ScheduledOptions;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const AutoflowEventTrigger = _zod.z.object({
    type: _zod.z.literal("event"),
    event: _zod.z.object({
        // CONCEPT WIP
        type: _zod.z.union([
            _zod.z.literal("created"),
            _zod.z.literal("updated")
        ]),
        resource: _zod.z.object({
            type: _zod.z.string(),
            id: _zod.z.instanceof(_bson.ObjectId)
        })
    })
});
const ScheduledOptions = _zod.z.object({
    // TODO could this be a union?
    scheduled_time: _zod.z.string().optional(),
    scheduled_cron: _zod.z.string().optional(),
    scheduled_rate: _zod.z.string().optional()
});
const AtLeastOneScheduled = ScheduledOptions.refine((data)=>{
    const { scheduled_time, scheduled_cron, scheduled_rate } = data;
    return scheduled_time !== undefined || scheduled_cron !== undefined || scheduled_rate !== undefined;
}, {
    message: "At least one of scheduledTime, scheduledCron, or scheduledRate must be provided"
});
const AutoflowScheduledTrigger = _zod.z.object({
    type: _zod.z.literal("scheduled"),
    scheduled: _zod.z.object({
        recurring: _zod.z.boolean().default(false),
        expression: _zod.z.object({
            ...ScheduledOptions.pick({
                scheduled_time: true,
                scheduled_cron: true,
                scheduled_rate: true
            }).shape
        }),
        inaugural_time_date: _zod.z.date().optional(),
        start_time_date: _zod.z.date().optional(),
        end_time_date: _zod.z.date().optional(),
        timezone: _zod.z.string().optional()
    })
});
const AutoflowTrigger = _zod.z.discriminatedUnion("type", [
    AutoflowEventTrigger,
    AutoflowScheduledTrigger
]);
